import React from 'react'

import { Alert } from 'components/shared/Alert/Alert'

type MessageAlertProps = Pick<
  React.ComponentProps<typeof Alert>,
  'className' | 'message' | 'size' | 'variant' | 'isInitialised'
>

export const MessageAlert = ({
  className,
  message,
  size,
  variant,
  isInitialised,
}: MessageAlertProps) => (
  <Alert {...{ className, message, size, variant, isInitialised }}>
    <Alert.Message />
  </Alert>
)
